/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import SiteMeta from '@naruto/bgdapp/src/reducers/stores/site-meta';
import SITE_META_ACTION from '@naruto/bgdapp/src/reducers/cores/site-meta/events';
import { CreateSiteMetaReducerParams, SiteMetaActionTypes } from './types';

export function createSiteMetaReducer(params: CreateSiteMetaReducerParams): Reducer<SiteMeta, SiteMetaActionTypes> {
  return (state = params.initialState, action: SiteMetaActionTypes): SiteMeta =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case SITE_META_ACTION.SET_SITE_META_INITIALIZE:
          draft.initialize();
          break;
        case SITE_META_ACTION.SET_SITE_META_INFO:
          draft.updateSiteMetaInfo(action.siteMetaInfo);
          break;
        default:
          break;
      }
    });
}
